import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "ic-auth-wrapper",
	templateUrl: "./auth-wrapper.component.html",
	styleUrls: ["./auth-wrapper.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AuthWrapperComponent {
	@Input() width = "500px";
	@Input() isCenteredLogo = true;
	@Input() contentBoxPadding = "24px";
}
